import CrudCustom from '../../../libs/custom/CrudCustom';


let SandingAsetPerAkunService = new CrudCustom('/sanding-aset-transaksis');
export default SandingAsetPerAkunService;
